import { Outlet, useParams } from 'react-router-dom'

import { CompetenciesRootPageDocument } from 'generated/resources/graphql'
import { isEmpty } from 'lodash'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { CompetenciesFeaturesProvider } from 'modules/competencies/hooks/useCompetenciesFeatures'
import CollectionsBootstrap from 'modules/competencies/lib/CollectionsBootstrap'
import PageLoading from 'modules/layout/components/Page/Loading'

const RootPage = () => {
  const params = useParams()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(CompetenciesRootPageDocument, {
    variables: { companyId: company.id },
  })

  useEffect(() => {
    // Ensure we only track the first time the user visits the competencies module
    if (isEmpty(params)) track(trackingEvents.competencies.goToCompetencies)
  }, [])

  if (loading) {
    return <PageLoading />
  }

  const features = data?.features?.featuresConnection?.nodes || []
  const canManageCompetencies = data?.competencies?._policies?.competenciesManage?.can ?? false

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => canManageCompetencies}>
        <CompetenciesFeaturesProvider features={features}>
          <Outlet />
        </CompetenciesFeaturesProvider>
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
